import Vue from 'vue'
import VeeValidate from 'vee-validate'
import Validator from './validator'
import validationFields from '@common/lang/validationFields'

function initValidation (store) {
  const locale = store.state.locale.split('_').shift()

  if (locale !== 'en') {
    import('vee-validate/dist/locale/' + locale
      /* webpackChunkName: "validation-locales" */
      /* webpackInclude: /es.js/ */
      /* webpackMode: "lazy-once" */)
      .then(dictionary => {
        Validator.localize(locale, dictionary)
      })
  }

  Validator.localize(validationFields)

  const config = {
    events: 'blur',
    inject: false,
    fieldsBagName: 'validationFieldBag',
    errorBagName: 'validationErrorBag',
    locale
  }

  Vue.use(VeeValidate, config)
}

export default initValidation
